import { gql } from "@apollo/client";


export const UPDATE_SHOP_SETTING_SERVICE = gql`
mutation UpdateShopCommissionService($data: ShopSettingCommissionInput!, $where: ShopSettingCommissionWhereInputOne!) {
  updateShopCommissionService(data: $data, where: $where) {
    id
  }
}
`;

export const UPDATE_SHOP = gql`
mutation UpdateShop($data: ShopInput!, $where: ShopWhereInputOne!) {
  updateShop(data: $data, where: $where) {
    id
  }
}
`;

export const CONNECT_SHOP_PAGE = gql`
mutation ConnectShopPage($where: ShopWhereInputOne!, $pageId: String!, $name: String!, $token: String!) {
  connectShopPage(where: $where, pageId: $pageId, name: $name, token: $token) {
    id
  }
}
`;